import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BrandMark from './BrandMark';

function MarketingFooter() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
  };

  return (
    <footer id="contact">
      <div className="wrap">
        <div className="foot-main">
          <div className="foot-brand">
            <div className="brand" style={{ gap: 11, marginBottom: 14 }}>
              <BrandMark size={38} />
              <span className="name" style={{ fontSize: 22 }}>
                Nurturer
              </span>
            </div>
            <div className="email">hello@nurturer.ai</div>
          </div>
          <div className="foot-col">
            <h4>Company</h4>
            <ul>
              <li><a href="#support">Support</a></li>
              <li><Link to="/contact-us">Contact</Link></li>
              <li><a href="#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="subscribe">
            <div className="lbl">Get notified about news &amp; offers</div>
            <form className="subform" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Enter email address"
                aria-label="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </div>
        <div className="foot-bottom">
          <span>&copy; 2026 Nurturer. All rights reserved.</span>
          <span>6751 Columbia Gateway Drive, Suite 300, Columbia, MD 21046</span>
          <span className="legal">
            <a href="#terms">Terms &amp; Conditions</a>
            <a href="#privacy">Privacy Policy</a>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default MarketingFooter;
